import styled from '@emotion/styled/macro'
import { Button, Menu } from '@mui/material'
import { DivProps } from 'commons/types/htmlElements'
import { theme as newTheme } from 'styles/theme/hav-theme'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { shouldForwardProp } from 'commons/utils/mui'

interface LinksStyledProps extends DivProps {
  width?: string | number
  margin?: string
  disabled?: boolean
  fullWidth?: boolean
}

type TextButtonProps = {
  disabled?: boolean
}

type ExpandMoreIconProps = {
  disabled?: boolean
}

export const LinkStyled = styled('div', { shouldForwardProp })<LinksStyledProps>`
  display: flex;
  align-items: center;
  color: ${newTheme.colors.neutral.white};
  font-size: ${newTheme.typography.sizes.xs};
  font-weight: ${newTheme.typography.weight.xl};
`

export const ButtonStyled = styled(Button)`
  border-radius: 4px;
  height: 30px;
  padding: 0 ${newTheme.spacing.sm};
  border: 1px solid ${newTheme.colors.neutral.mediumhover};
`

type StyledMenuProps = {
  minwidth?: number
}

export const MenuStyled = styled(Menu)<StyledMenuProps>`
  & .MuiPaper-root {
    min-width: ${({ minwidth }) => `${minwidth}px` || 'auto'};

    & .MuiMenuItem-root {
      font-size: ${newTheme.typography.sizes.xs};
    }
  }
`

export const ExpandMoreIcon = styled(ExpandMore, {
  shouldForwardProp
})<ExpandMoreIconProps>`
  color: ${({ disabled }) =>
    disabled ? newTheme.colors.neutral.light : newTheme.colors.primary.main};
  font-size: ${newTheme.typography.sizes.sm};
`

export const TextLink = styled('a')`
  color: ${newTheme.colors.primary.main};
  font-family: ${newTheme.typography.family.primary};
  font-weight: ${newTheme.typography.weight.md};
  text-decoration: ${newTheme.typography.decoration.underline};
  margin-left: ${newTheme.spacing.xs};
  text-transform: none;
`

export const TextButton = styled('span', { shouldForwardProp })<TextButtonProps>`
  white-space: nowrap;
  text-transform: none;
  color: ${({ disabled }) =>
    disabled ? newTheme.colors.neutral.light : newTheme.colors.primary.main};

  font-weight: ${newTheme.typography.weight.xl};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:disabled {
    color: ${newTheme.colors.neutral.light};
    cursor: not-allowed;
  }
`
